import type { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import type { AuthErrorResponse } from '@/types/api/auth'

function detailToMessage(detail: AuthErrorResponse['detail']): string | null {
  if (typeof detail === 'string' && detail.length > 0) {
    return detail
  }

  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0]
    if (first && typeof first.msg === 'string') {
      return first.msg
    }
  }

  return null
}

export function getAuthErrorMessage(error: unknown): string {
  if (!error || typeof error !== 'object') {
    return 'Something went wrong. Try again.'
  }

  const fetchError = error as FetchBaseQueryError
  if ('data' in fetchError && fetchError.data && typeof fetchError.data === 'object') {
    const data = fetchError.data as AuthErrorResponse
    const detailMessage = detailToMessage(data.detail)
    if (detailMessage) {
      return detailMessage
    }
    if (typeof data.message === 'string' && data.message.length > 0) {
      return data.message
    }
  }

  if ('error' in fetchError && typeof fetchError.error === 'string') {
    return fetchError.error
  }

  return 'Something went wrong. Try again.'
}
